import { __awaiter, __generator } from "tslib";
import { m365AppPlatformType } from '@office-start/data-resolver-app-pinning';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { getReferralFromElementId } from '@office-start/launcher-service';
import { logFeature } from '@office-start/telemetry-service';
export function appBarImpressionEventHandler(appBarImpressionEvent) {
    return __awaiter(this, void 0, void 0, function () {
        var data, getID_1, getIDs;
        return __generator(this, function (_a) {
            data = appBarImpressionEvent.data && appBarImpressionEvent.data();
            if (data) {
                getID_1 = function (tile) {
                    return tile.platformType === m365AppPlatformType
                        ? m365AppPlatformType // Use the generic m365app platform type as the id for MOS apps
                        : getReferralFromElementId(tile.id);
                };
                getIDs = function (tiles) {
                    return tiles.map(function (tile) { return getID_1(tile); }).join();
                };
                logFeature({
                    area: 'AppBar',
                    eventName: KnownInstrumentationEvents.AppBarImpression,
                    featureName: "AppBar" /* KnownFeatureNames.AppBar */,
                    params: {
                        lockedTiles: getIDs(data.lockedTiles),
                        pinnedTiles: getIDs(data.pinnedTiles),
                        hoistedTile: data.hoistedTile ? getID_1(data.hoistedTile) : '',
                        overflowFiles: getIDs(data.overflowTiles),
                    },
                });
            }
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=appBarImpressionEventHandler.js.map